import Image from "next/image";
import React from "react";
import { motion } from "framer-motion";

const PeranUmkm = () => {
  return (
    <div className="relative flex flex-col justify-center items-center px-5 md:px-10 lg:px-16 gap-7 overflow-hidden">
      <motion.div
        className="w-full text-2xl sm:text-4xl lg:text-5xl font-bold leading-tight"
        initial={{ x: 50, opacity: 0 }}
        whileInView={{
          x: 0,
          opacity: 1,
        }}
        transition={{
          duration: 0.5,
          delay: 1,
          ease: "easeInOut"
        }}
        viewport={{ once: true }}
      >
        Peran UMKM dalam Rancangan Awal RPJMN
        <br />
        Tahun 2025 - 2029
      </motion.div>
      <motion.div
        className="flex flex-col-reverse md:flex-row justify-between items-stretch w-full h-full rounded-4xl bg-[url('/image/bg-peran-umkm.webp')] bg-cover bg-center bg-no-repeat px-8 md:px-12 lg:px-20 gap-5 sm:gap-10 md:gap-20 overflow-hidden"
        initial={{ opacity: 0, delay: 1 }}
        whileInView={{ opacity: 1 }}
        transition={{
          delay: 1.25,
          duration: 0.5,
          ease: "easeInOut"
        }}
        viewport={{ once: true }}
      >
        <motion.div
          className="relative flex justify-center items-end w-full md:w-1/2 h-auto pt-0 md:pt-5"
          initial={{
            scale: 2,
            opacity: 0,
          }}
          whileInView={{
            scale: 1,
            opacity: 1,
          }}
          transition={{
            duration: 1,
            ease: "easeInOut",
            delay: 1.5,
          }}
          viewport={{ once: true }}
        >
          <Image
            src="/image/prabowo-gibran.webp"
            alt="image"
            fill
            className="object-contain"
          />
        </motion.div>
        <div className="flex flex-col justify-center w-full md:w-1/2 text-white pt-10 pb-0 md:py-10 gap-5">
          <motion.div
            className="text-3xl sm:text-5xl md:text-4xl lg:text-5xl xl:text-6xl font-bold text-center md:text-left w-full"
            initial={{
              scale: 0.8,
              opacity: 0,
              y: -10,
            }}
            whileInView={{
              scale: 1,
              opacity: 1,
              y: 0,
            }}
            transition={{
              duration: 1,
              ease: "easeInOut",
              delay: 2.5,
            }}
            viewport={{ once: true }}
          >
            Visi RPJMN
          </motion.div>
          <motion.div
            className=" text-xl sm:text-3xl md:text-xl lg:text-2xl xl:text-4xl font-medium leading-relaxed text-center md:text-left w-full"
            initial={{
              opacity: 0,
            }}
            whileInView={{
              opacity: 1,
            }}
            transition={{
              duration: 2,
              ease: "easeInOut",
              delay: 3.5,
            }}
            viewport={{ once: true }}
          >
            “Bersama Indonesia Maju <br /> Menuju Indonesia Emas <br /> 2045”
          </motion.div>
        </div>
      </motion.div>
    </div>
  );
};

export default PeranUmkm;
